/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - Territory Management
=========================================================
*/
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useSales from "hooks/useSales";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import useDealer from "hooks/useDealer";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  Autocomplete,
  Avatar,
  AvatarGroup,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import dayjs from "dayjs";
import CustomPagination from "examples/CustomPagination/CustomPagination";

export default function Data() {
  const navigate = useNavigate();
  const {
    getSalesList,
    deleteSales,
    resendInvitation,
    assignDealers,
    salesList,
    setTarget,
    getTargetBySalesId,
  } = useSales();
  const { getdealerOptionList } = useDealer();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState({});
  const [dealerList, setDealerList] = useState([]);
  const [open, setOpen] = useState(false);
  const [targetModal, setTargetModal] = useState(false);
  const [targetViewModal, setTargetViewModal] = useState(false);
  const [selectedSales, setSelectedSales] = useState();
  const [targetData, setTargetData] = useState([]);

  // Pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [total, setTotal] = useState(0);

  const openDialogHandler = (sales) => {
    setSelectedSales(sales);
    setOpen(true);
  };

  const openSetTargetDialogHandler = (sales) => {
    setSelectedSales(sales);
    setTargetModal(true);
  };

  const openSetTargetViewDialogHandler = (sales) => {
    setSelectedSales(sales);
    setTargetViewModal(true);
  };

  const handleTargetClose = () => {
    setTargetModal(false);
    setSelectedSales(null);
  };

  const handleTargetViewClose = () => {
    setTargetViewModal(false);
    setSelectedSales(null);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedSales(null);
  };

  const SalesActions = ({
    onEdit,
    onDelete,
    onAssign,
    onResentinvite,
    salesId,
    setTargetHandler,
    viewTarget,
  }) => {
    return (
      <MDBox display="flex" justifyContent="center">
        <MDButton variant="outlined" color="secondary" onClick={setTargetHandler} sx={{ mr: 1 }}>
          Set Target
        </MDButton>
        <MDButton variant="outlined" color="dark" onClick={viewTarget} sx={{ mr: 1 }}>
          View Target
        </MDButton>
        <MDButton
          variant="outlined"
          color="secondary"
          onClick={onResentinvite}
          sx={{ mr: 1 }}
          disabled={loading[salesId]?.resend}
        >
          {loading[salesId]?.resend ? "Resending..." : "Resend Invite"}
        </MDButton>
        <MDButton variant="contained" color="dark" onClick={onAssign} sx={{ mr: 1 }}>
          Assign Dealer
        </MDButton>
        <MDButton variant="contained" color="info" onClick={onEdit} sx={{ mr: 1 }}>
          <EditIcon />
        </MDButton>
        <MDButton
          variant="contained"
          color="error"
          onClick={onDelete}
          disabled={loading[salesId]?.delete}
        >
          {loading[salesId]?.delete ? "..." : <DeleteIcon />}
        </MDButton>
        <ResponsiveDialog
          open={open}
          onClose={handleClose}
          dealerList={dealerList}
          selectedSales={selectedSales}
          assignDealers={assignDealers}
          fetchList={fetchList}
        />
        <SetTargetDialog
          open={targetModal}
          onClose={handleTargetClose}
          selectedSales={selectedSales}
          setTarget={setTarget}
        />

        <ViewTargetDialog
          open={targetViewModal}
          onClose={handleTargetViewClose}
          selectedSales={selectedSales}
          getTargetBySalesId={getTargetBySalesId}
          setPage={setPage}
          totalPage={totalPage}
          page={page}
          targetData={targetData}
          setTargetData={setTargetData}
          setTotalPage={setTotalPage}
        />
      </MDBox>
    );
  };

  const getInitials = (name) => name.charAt(0).toUpperCase();

  const classicColors = [
    "#1E3A8A", // Navy Blue
    "#4F46E5", // Indigo
    "#0369A1", // Deep Blue
    "#334155", // Dark Gray
    "#1E40AF", // Royal Blue
    "#64748B", // Muted Gray-Blue
    "#3B82F6", // Standard Blue
    "#475569", // Soft Dark Gray
    "#2563EB", // Bright Blue
    "#1E293B", // Almost Black-Gray
  ];

  // Function to get color based on index
  const getColor = (index) => classicColors[index % classicColors.length];

  const Dealers = ({ dealers = [] }) => {
    return (
      <MDBox display="flex" alignItems="center">
        <AvatarGroup max={4} sx={{ flexDirection: "row-reverse" }}>
          {dealers.map((item, index) => (
            <Tooltip key={item?.userId?.name} title={item?.userId?.name} arrow>
              <Avatar
                sx={{
                  bgcolor: getColor(index),
                  color: "white",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.2)",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                  },
                }}
              >
                {item?.userId?.img ? (
                  <img src={item?.userId?.img} alt={item?.userId?.name} />
                ) : (
                  getInitials(item?.userId?.name)
                )}
              </Avatar>
            </Tooltip>
          ))}
        </AvatarGroup>
      </MDBox>
    );
  };

  const SalesInfo = ({ name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const rows = data?.map((sales) => ({
    name: <SalesInfo name={sales.userId?.name} email={sales?.userId?.email} />,
    phoneNumber: `${sales?.userId?.countryCode} ${sales?.userId?.mobile}`,
    status: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {sales?.userId?.status}
      </MDTypography>
    ),
    dealers: <Dealers dealers={sales?.dealer} />,
    actions: (
      <SalesActions
        onEdit={() => navigate(`/sales-team/edit?id=${sales?._id}`)}
        onDelete={() => handleDeleteSales(sales)}
        onAssign={() => openDialogHandler(sales)}
        onResentinvite={() => handleResendInvite(sales._id)}
        setTargetHandler={() => openSetTargetDialogHandler(sales)}
        viewTarget={() => {
          openSetTargetViewDialogHandler(sales);
          getTargetBySalesId(sales?._id).then((res) => {
            if (res.success) {
              setTargetData(res?.data?.targets);
              setPage(res.data.page);
              setLimit(res.data.limit);
              setTotalPage(res.data.pages || 1);
              setTotal(res.data.total || 0);
            }
          });
        }}
      />
    ),
  }));

  const fetchList = async () => {
    await getSalesList();
  };

  const handleDeleteSales = async (sales) => {
    if (window.confirm("Are you sure you want to delete this sales rep?")) {
      if (sales?.dealer?.length > 0) {
        alert("You need to reassign the dealers before deleting this sales rep.");
        return;
      }
      setLoading((prev) => ({ ...prev, [sales._id]: { ...prev[sales._id], delete: true } }));
      try {
        const res = await deleteSales(sales._id);
        if (res.success) {
          alert("Sales Rep deleted successfully!");
          fetchList();
        }
      } catch (err) {
        console.error("Error deleting sales rep:", err);
        alert("An error occurred while deleting the sales rep.");
      } finally {
        setLoading((prev) => ({ ...prev, [sales._id]: { ...prev[sales._id], delete: false } }));
      }
    }
  };

  const handleResendInvite = async (salesId) => {
    if (window.confirm("Are you sure you want to resend the invitation?")) {
      setLoading((prev) => ({ ...prev, [salesId]: { ...prev[salesId], resend: true } }));
      try {
        const res = await resendInvitation(salesId);
        if (res.success) {
          alert("Invitation resent successfully!");
        } else {
          alert("Failed to resend invitation. Please try again.");
        }
      } catch (err) {
        console.error("Error resending invitation:", err);
        alert("An error occurred while resending the invitation.");
      } finally {
        setLoading((prev) => ({ ...prev, [salesId]: { ...prev[salesId], resend: false } }));
      }
    }
  };

  const fetchDealerOptionList = async () => {
    const response = await getdealerOptionList();
    if (response.success) {
      setDealerList(response.data);
    }
  };

  useEffect(() => {
    if (salesList.salesReps) {
      setData(salesList.salesReps);
    }
  }, [salesList]);

  useEffect(() => {
    fetchDealerOptionList();
  }, []);

  return {
    columns: [
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Phone Number", accessor: "phoneNumber", align: "left" },
      { Header: "Status", accessor: "status", align: "left" },
      { Header: "Dealers", accessor: "dealers", align: "left" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],
    rows,
  };
}

const ResponsiveDialog = ({
  open,
  onClose,
  dealerList = [],
  selectedSales,
  assignDealers,
  fetchList,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedDealerIds, setSelectedDealerIds] = useState([]);

  useEffect(() => {
    if (selectedSales?.dealer) {
      const preSelectedIds = selectedSales.dealer.map((dealer) => dealer._id);
      setSelectedDealerIds(preSelectedIds);
    }
  }, [selectedSales, dealerList, open]);

  const handleDealerChange = (event, selectedDealers) => {
    const selectedIds = selectedDealers.map((dealer) => dealer._id);
    setSelectedDealerIds(selectedIds);
  };

  const handleAssignDealer = async () => {
    try {
      const response = await assignDealers(selectedSales._id, { dealerIds: selectedDealerIds });
      if (response.success) {
        fetchList(); // Refresh data after assigning
        onClose();
      } else {
        alert(response.message || "Error assigning dealers");
      }
    } catch (error) {
      console.error("Error assigning dealers:", error);
      alert("An unexpected error occurred.");
    }
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      // onClose={onClose}
      BackdropProps={{
        style: { backgroundColor: "hsla(0, 0.00%, 0.00%, 0.12)" }, // Light transparent background
      }}
    >
      <DialogTitle id="responsive-dialog-title">Assign Dealers</DialogTitle>
      <DialogContent>
        <Autocomplete
          multiple
          id="dealer-selection"
          options={dealerList}
          disableCloseOnSelect
          getOptionLabel={(option) =>
            `${option.userId.name} ${option.bussinessName ? `(${option.bussinessName})` : ""}`
          }
          value={dealerList.filter((dealer) => selectedDealerIds.includes(dealer._id))} // Set selected dealers
          onChange={handleDealerChange} // Update state on change
          renderOption={(props, option, { selected }) => (
            <li {...props} key={option._id}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.userId.name} {option.bussinessName && `(${option.bussinessName})`}
            </li>
          )}
          style={{ width: 500 }}
          renderInput={(params) => <TextField {...params} placeholder="Select Dealers" />}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleAssignDealer} autoFocus>
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const SetTargetDialog = ({ open, onClose, selectedSales, setTarget }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [targetValue, setTargetValue] = useState();
  const currentDate = dayjs();

  const handleAssignTarget = async () => {
    if (!targetValue || targetValue <= 0) {
      alert("Please enter a valid target value greater than 0.");
      return;
    }

    try {
      const response = await setTarget(selectedSales._id, { target: targetValue });
      if (response.success) {
        alert("Target assigned successfully!");
        onClose();
      } else {
        alert(response.message || "Error assigning target");
      }
    } catch (error) {
      console.error("Error assigning target:", error);
      alert("An unexpected error occurred.");
    }
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      BackdropProps={{
        style: { backgroundColor: "hsla(0, 0.00%, 0.00%, 0.12)" }, // Light transparent background
      }}
    >
      <DialogTitle id="responsive-dialog-title">Assign Target</DialogTitle>
      <DialogContent>
        {/* Target Input Field */}
        <TextField
          label="Target Value"
          type="number"
          fullWidth
          margin="dense"
          value={targetValue}
          onChange={(e) => {
            const value = Math.max(0, Number(e.target.value)); // Ensure value is at least 0
            setTargetValue(value);
          }}
          inputProps={{ min: 0 }}
        />

        {/* Date Picker */}
        <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth>
          <DemoContainer components={["DatePicker", "DatePicker"]}>
            <DatePicker
              label="Year"
              openTo="year"
              views={["year"]}
              value={currentDate}
              disabled // Disable selection
            />
            <DatePicker
              label="Month"
              openTo="month"
              views={["year", "month"]}
              value={currentDate}
              disabled // Disable selection
            />
          </DemoContainer>
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleAssignTarget} autoFocus>
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const ViewTargetDialog = ({
  open,
  onClose,
  selectedSales,
  getTargetBySalesId,
  setPage,
  totalPage,
  page,
  setTotalPage,
  targetData,
  setTargetData,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  // Handle page change
  const handlePageChange = (newPage) => {
    getTargetBySalesId(selectedSales?._id, { limit: 10, page: newPage }).then((res) => {
      if (res.success) {
        setTargetData(res?.data?.target);
        setPage(res.data.page);
        setTotalPage(res.data.pages || 1);
        setTotal(res.data.total || 0);
      }
    });
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      BackdropProps={{
        style: { backgroundColor: "hsla(0, 0.00%, 0.00%, 0.12)" }, // Light transparent background
      }}
    >
      <DialogTitle id="responsive-dialog-title">Target</DialogTitle>
      <DialogContent>
        <MDBox pt={3}>
          {/* Table to display targets */}
          <TableContainer component={Paper}>
            <Table>
              {/* <TableHead> */}
              <TableRow>
                <TableCell>
                  <b>Year</b>
                </TableCell>
                <TableCell>
                  <b>Month</b>
                </TableCell>
                <TableCell>
                  <b>Target</b>
                </TableCell>
                <TableCell>
                  <b>Achieved</b>
                </TableCell>
                <TableCell>
                  <b>Percentage</b>
                </TableCell>
              </TableRow>
              {/* </TableHead> */}
              <TableBody>
                {targetData?.length > 0 ? (
                  targetData?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.year}</TableCell>
                      <TableCell>{item.month}</TableCell>
                      <TableCell>{item.target.toLocaleString()}</TableCell>
                      <TableCell>{item.achieve.toLocaleString()}</TableCell>
                      <TableCell>{(item.percentage * 100).toFixed(2)}%</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </MDBox>
        <MDBox sx={{ width: "100%", display: "flex", justifyContent: "start", marginTop: "1rem" }}>
          <CustomPagination
            totalCount={totalPage}
            currentPage={page}
            onPageChange={handlePageChange}
          />
        </MDBox>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
